
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu';

interface NavItem {
  name: string;
  href: string;
  hasDropdown?: boolean;
  isNcolo?: boolean;
  subItems?: { name: string; href: string }[];
}

interface NavigationItemsProps {
  navItems: NavItem[];
  onNavClick: (item: NavItem) => void;
}

const NavigationItems = ({ navItems, onNavClick }: NavigationItemsProps) => {
  const [hoveredNcolo, setHoveredNcolo] = useState(false);
  const [hoveredMobile, setHoveredMobile] = useState(false);

  return (
    <nav className="hidden lg:flex items-center">
      <NavigationMenu>
        <NavigationMenuList className="space-x-6">
          {navItems.map((item) => (
            <NavigationMenuItem key={item.name}>
              {item.hasDropdown ? (
                <>
                  <NavigationMenuTrigger className="text-gray-600 hover:text-nexx-green transition-colors duration-200 font-medium bg-transparent px-2 h-auto data-[state=open]:bg-transparent text-base">
                    {item.name}
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="bg-white border border-gray-200 shadow-lg rounded-md p-2 min-w-[200px]">
                    <div className="space-y-1">
                      {item.subItems?.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          className="block px-3 py-2 text-sm text-gray-600 hover:text-nexx-green hover:bg-gray-50 rounded-md transition-colors duration-200"
                        >
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  </NavigationMenuContent>
                </>
              ) : (
                item.href.startsWith('/') && !item.isNcolo ? (
                  item.name === 'Mobile Solutions' ? (
                    <div className="relative">
                      <Link
                        to={item.href}
                        onMouseEnter={() => setHoveredMobile(true)}
                        onMouseLeave={() => setHoveredMobile(false)}
                        className="text-gray-600 hover:text-pink-600 hover:shadow-lg hover:shadow-pink-500/25 py-1 rounded-md hover:bg-pink-50 transition-all duration-200 font-medium px-2"
                      >
                        {item.name}
                      </Link>
                      <div className={`absolute -bottom-6 left-1/2 transform -translate-x-1/2 transition-opacity duration-200 pointer-events-none z-50 ${hoveredMobile ? 'opacity-100' : 'opacity-0'}`}>
                        <div className="bg-pink-600 text-white px-2 py-1 rounded text-xs whitespace-nowrap">
                          Powered by T-Mobile
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      className="text-gray-600 hover:text-nexx-green transition-colors duration-200 font-medium px-2"
                    >
                      {item.name}
                    </Link>
                  )
                ) : (
                  item.isNcolo ? (
                    <div className="relative">
                      <button
                        onClick={() => onNavClick(item)}
                        onMouseEnter={() => setHoveredNcolo(true)}
                        onMouseLeave={() => setHoveredNcolo(false)}
                        className="text-gray-600 hover:text-blue-600 hover:shadow-lg hover:shadow-blue-500/25 py-1 rounded-md hover:bg-blue-50 transition-all duration-200 font-medium px-2"
                      >
                        {item.name}
                      </button>
                      <div className={`absolute -bottom-6 left-1/2 transform -translate-x-1/2 transition-opacity duration-200 pointer-events-none z-50 ${hoveredNcolo ? 'opacity-100' : 'opacity-0'}`}>
                        <div className="bg-blue-600 text-white px-2 py-1 rounded text-xs whitespace-nowrap">
                          Powered by NCOLO
                        </div>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => onNavClick(item)}
                      className="text-gray-600 hover:text-nexx-green transition-colors duration-200 font-medium px-2"
                    >
                      {item.name}
                    </button>
                  )
                )
              )}
            </NavigationMenuItem>
          ))}
        </NavigationMenuList>
      </NavigationMenu>
    </nav>
  );
};

export default NavigationItems;
